// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk/opsHub/lazy/" + chunkId + "-" + {"141":"82e76a","287":"1e40be","479":"c2deb8","545":"71f713","768":"88f18c","862":"ac6fb8","946":"8baf33","970":"ec2b2e"}[chunkId] + ".js";
};